import axios from 'axios';
import { auth } from '../firebase';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const usedUrl = BASE_URL;

const getAuthHeaders = async () => {
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error('Authentication is required');
  }

  const token = await currentUser.getIdToken();

  return {
    Authorization: `Bearer ${token}`,
  };
};

const postWithAuth = async (path, data) => {
  const headers = await getAuthHeaders();

  const response = await axios({
    method: 'post',
    url: `${usedUrl}${path}`,
    headers,
    data,
  });

  return response.data;
};

export const getDigisData = async (userEmail, startDate, endDate) => {
  return postWithAuth('/digis', {
    startDate,
    endDate: endDate || startDate,
    userEmail,
  });
};

export const getDoitData = async (userEmail, startDate, endDate) => {
  return postWithAuth('/doit', {
    startDate,
    endDate: endDate || startDate,
    userEmail,
  });
};

export const postDigisEntry = async (data) => {
  try {
    await postWithAuth('/entries/digis', data);
  } catch (error) {
    console.log(error);
  }
};

export const refreshDoitUnloggedUsers = async (data) => {
  try {
    return postWithAuth('/getUnlogged/doit', data);
  } catch (error) {
    console.log(error);
  }
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post(`${usedUrl}/public/password-reset`, {
    email,
  });

  return response.data;
};
